import { render, staticRenderFns } from "./ParentingAfterSeparationInstructions.vue?vue&type=template&id=4a9e58d0&scoped=true"
import script from "./ParentingAfterSeparationInstructions.vue?vue&type=script&lang=ts"
export * from "./ParentingAfterSeparationInstructions.vue?vue&type=script&lang=ts"
import style0 from "@/styles/_pdf.scss?vue&type=style&index=0&id=4a9e58d0&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9e58d0",
  null
  
)

export default component.exports